import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})

export class ModalComponent implements OnInit {

  showModal: boolean = false;
  dontShowAgain: boolean = false;


  ngOnInit(): void {
    const checkModalValue = localStorage.getItem('dontShowAgain')
    if (checkModalValue === 'true') {
      this.showModal = false;
    }
    else {
      this.showModal = true;
    }
    this.loadFromLocalStorage();
  }

  saveToLocalStorage() {
    localStorage.setItem('dontShowAgain', JSON.stringify(this.dontShowAgain));
  }

  loadFromLocalStorage() {
    const storedValue = localStorage.getItem('dontShowAgain');;
    if (storedValue) {
      this.dontShowAgain = JSON.parse(storedValue);
    }
  }

  // onCheckBoxChange(event: Event): any {
  //   this.dontShowAgain = (event.target as HTMLInputElement).checked;
  // }

  // @HostListener('window:click', ['$event'])
  // onWindowClick(event: MouseEvent): void {

  //   if (event.target) {
  //     this.closeModal();
  //   }
  // }

  closeModal(): any {
    if (this.dontShowAgain === true) {
      localStorage.setItem('dontShowAgain', 'true')
    }
    this.showModal = false;
  }
}
